import { render, staticRenderFns } from "./ChatImageLightbox.vue?vue&type=template&id=818b27b4&scoped=true"
import script from "./ChatImageLightbox.vue?vue&type=script&lang=js"
export * from "./ChatImageLightbox.vue?vue&type=script&lang=js"
import style0 from "./ChatImageLightbox.vue?vue&type=style&index=0&id=818b27b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818b27b4",
  null
  
)

export default component.exports